export const wtb_rules_en = [
  // Page 1: Game Introduction & Basic Rules
  "Each round, try to spot the AI's answer and, in the end, guess who the AI is. You can also pretend to be the AI to trick others and earn points.",
  "AI Players are controlled by artificial intelligence. They try to mimic human-like responses while maintaining consistency.",
  "Human players need to answer questions naturally while trying to identify AI players. You can also try to mimic AI responses to deceive other players!",

  // Page 2: Game Phases
  "Each player answers the given question within the time limit. Try to write natural, human-like answers, or cleverly mimic AI responses to deceive others.",
  "Vote for the answer that seems most likely to be from an AI. You cannot vote for your own answer. If your answer receives votes, you earn points!",
  "In the final phase, vote for the player you think is the AI. Consider all answers from previous rounds.",

  // Page 3: Scoring & Tips
  "Earn 1 point for each vote your answer receives when others think it's from an AI",
  "Earn 5 points for correctly identifying the AI player in the final vote",
  "AI players don't earn points, they're just there to challenge you!",
  "Try to be unpredictable - sometimes act like a human, sometimes like an AI",
  "Pay attention to how other players vote - they might be trying to deceive you",
  "Balance between being human-like and AI-like in your answers",
];

export const wtb_rules_ko = [
  // Page 1: 게임 소개 및 기본 규칙
  "매 라운드마다 AI의 답변을 찾아내고, 최종적으로 누가 AI인지 맞추세요. 또한, 본인이 AI처럼 위장해 다른 플레이어를 속이고 점수를 얻을 수도 있습니다.",
  "AI 플레이어는 인공지능이 조종합니다. 일관성을 유지하면서 인간다운 답변을 하려고 노력합니다.",
  "인간 플레이어는 자연스러운 답변을 하면서 AI 플레이어를 찾아내야 합니다. 다른 플레이어를 속이기 위해 AI처럼 답변할 수도 있습니다!",

  // Page 2: 게임 진행 단계
  "각 플레이어는 제한 시간 내에 주어진 질문에 답변합니다. 자연스럽고 인간다운 답변을 하거나, 다른 플레이어를 속이기 위해 AI처럼 답변해보세요.",
  "AI의 답변으로 보이는 답변에 투표하세요. 자신의 답변에는 투표할 수 없습니다. 만약 당신의 답변이 투표를 받으면 점수를 얻습니다!",
  "마지막 단계에서 AI라고 생각되는 플레이어에게 투표하세요. 이전 라운드의 모든 답변을 고려하세요.",

  // Page 3: 점수 및 팁
  "다른 플레이어들이 AI의 답변이라고 생각하여 투표할 때마다 1점씩 획득",
  "마지막 투표에서 AI 플레이어를 정확히 찾아내면 5점 획득",
  "AI 플레이어는 점수를 얻지 않으며, 단지 당신을 도전하기 위해 존재합니다!",
  "예측 불가능하게 행동하세요 - 때로는 인간처럼, 때로는 AI처럼 답변해보세요",
  "다른 플레이어들의 투표 패턴을 주의 깊게 살펴보세요 - 그들도 당신을 속이려 할 수 있습니다",
  "인간다운 답변과 AI다운 답변 사이의 균형을 맞추세요",
];
